/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

loadStyles([{"rawString":".ms-SearchBoxSmallExample{width:208px}"}]);
/* tslint:enable */